module.exports = {};



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/internals/iterators.js
// module id = 58
// module chunks = 0 1